import { Box, Collapse, Table, TableBody,TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { TableCellWithTooltip } from 'common/components/sharedCustomComponents/TableCellWithTooltip';

import { StepFunctionExecutionDetails } from '../AccountLinkingDashboardTypeDefs';

export function AccountLinkingDashboardRowInnerTable({ open, rowDetails } : Readonly<{open: boolean, rowDetails: StepFunctionExecutionDetails}>) {
    return (
        <TableRow className='collapsing-row' sx={{ backgroundColor:'secondary.light' }}>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout='auto' unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <Typography variant='h6' gutterBottom component='div'>
                            {(rowDetails?.djLinkUserFailures.length > 0 ? 'Linking Errors' : 'General Errors')}
                        </Typography>
                        <Table size='small' sx={{ tableLayout:'fixed' }}>
                            <TableHead>
                                <TableRow>
                                    {rowDetails?.djLinkUserFailures.length > 0 ? (
                                        <>
                                            <TableCell width='17.5%'>User Name</TableCell>
                                            <TableCell width='17.5%'>User Email</TableCell>
                                            <TableCell width='20%'>Subject</TableCell>
                                            <TableCell width='10%'>Billing Account</TableCell>
                                            <TableCell width='35%'>Error Message(s)</TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell width='15%'>Step Name</TableCell>
                                            <TableCell width='15%'>Error Type</TableCell>
                                            <TableCell width='70%'>Error Message</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowDetails?.djLinkUserFailures.length > 0 ?
                                    rowDetails?.djLinkUserFailures?.map((issue) => (
                                        <TableRow className='inner-row' key={issue.subjectId + '_' + issue.billingAccount}>
                                            <TableCellWithTooltip
                                                value={issue.firstName && issue.lastName
                                                    ? `${issue.firstName} ${issue.lastName}`
                                                    : 'Unknown User'}
                                                tableCellProps={{ component:'th', scope:'row' }}
                                            />
                                            <TableCellWithTooltip value={issue.userEmail || 'Unknown'}/>
                                            <TableCellWithTooltip value={issue.subjectId}/>
                                            <TableCellWithTooltip value={issue.billingAccount}/>
                                            <TableCellWithTooltip value={issue.errorMessages.join('; ')}/>
                                        </TableRow>))
                                    :
                                    <TableRow className='inner-row' key={rowDetails?.failedStepName}>
                                        <TableCellWithTooltip
                                            value={rowDetails?.failedStepName}
                                            tableCellProps={{ component:'th', scope:'row' }}
                                        />
                                        <TableCellWithTooltip value={rowDetails?.errorType}/>
                                        <TableCellWithTooltip value={rowDetails?.errorMessage}/>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
}
